$(document).ready(function(){
  $('.custom_autoplay_slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 6000,
      cssEase: "linear",
      pauseOnHover: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1,
          }
        },
      ]
  });
  $('.slide_init').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots:true,
    autoplay:true,
    autoplaySpeed: 2000,
  });
  $('.header-toolbar__slides').slick({
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay:true,
    autoplaySpeed: 5000,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-width="1.75" d="m1 5 7 7 7-7"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-width="1.75" d="m1 5 7 7 7-7"></path></svg></button>',
  });
  $(document).on("click", ".tag_header", function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });
  
  //search
  $(document).on('click', '.clearSearch', function(){
    var searcvalue = $('#blogsearch').val().toLowerCase();
    console.log(searcvalue);
    $(this).hide();
    $('#blogsearch').val("");
    $('.no-results').hide();
    $('.main-blog__article,.main-blog__content-wrapper').show();
  });

  var $block = $('.no-results');
  
  $("#blogsearch").keyup(function() {
      var $length = 0;
      var val = $(this).val().toLowerCase();
      var isMatch = false;
    $(".main-blog__content-wrapper").each(function(i) {
      var $length = 0;
        $(this).find(".article-card").each(function(i) {
            var content = $(this).html();
            if(content.toLowerCase().indexOf(val) == -1) {
               $(this).parents('.main-blog__article').hide();
               $(this).parents('.blog___posts').find(".pagination").hide();
            
            } else {
                isMatch = true;
                $(this).parents('.main-blog__article').show();
                $(this).parents('.blog___posts').find(".pagination").show();
              $length += 1;
            }
        });
      if($length  == 0){
        $(this).hide();
      }else{
        $(this).show();
      }
          // console.log('this length::'+$length);
      });
    
    if (val.length > 0) {
      console.log('Showing clear button');
      $(".clearSearch").show();
    } else {
      console.log('Hiding clear button');
      $(".clearSearch").hide();
    }
    
    $block.toggle(!isMatch);
  });

  //end search
  $('[href="#recover-password"],[href="#customer-login"]').on("click",function(){
       $('html, body').animate({scrollTop:0}, 'slow');
        // return false;
  });
  if (window.location.href.indexOf("/account/login#recover") > -1) {
      // Redirect to "/account/login#recover-password"
      window.location.href = "/account/login#recover-password";
      $('html, body').scrollTop(0);
  }
  
  (function () {
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	};
  })();

  if(performance.navigation.type == 2){
   location.reload(true);
  }

  window.onbeforeunload = function() {
    window.location.reload(true);
  }

  function loadmoreByButton(){      
    var nextUrl = $('.cdk__more').attr("link"); 
    $('body').on('click', '.cdk__more', function(){ 
      $(this).text('Loading...');
        $.ajax({
        url: nextUrl,
        type: 'GET',
        beforeSend: function() {
          
        }
        })
        .done(function(data) {
          $('#article_load_more').append($(data).find('#article_load_more').html());
           $('#loadMoreBtn').html($(data).find('#loadMoreBtn').html());
           nextUrl = $(data).find('.cdk__more').attr("link");  
        });
    }); 

    $('body').on('click', '.tag-catg-button:not(.blog-catg-button)', function(e){ 
      e.preventDefault() 
      var nextUrl = $(this).attr("href"); 
      var ThisText = $(this).attr('data-tag-name'); 
      console.log('nextUrl::'+nextUrl);
      $(this).text('Loading...');
        $.ajax({
        url: nextUrl,
        type: 'GET',
        beforeSend: function() {
         
        }
        })
        .done(function(Tdata) {
          $('.blog-catg-list').hide(); 
          $('.tag-catg-button[data-tag-name="'+ThisText+'"]').text(ThisText);
          $('#cdk_loadmore_tag').html($(Tdata).find('#cdk_loadmore_tag').html()); 
          console.log($(Tdata).find('#cdk_loadmore_tag').html())
        });
    }); 
  }
  loadmoreByButton();

  $(document).on('click', '.site-overlay', function(){
      $('html').css('overflow', '');
  });
  
  var counter = 0;
  var checkInterval = setInterval(function(){
      if (window.location.href.indexOf("pages") !== -1) {
          if ($('meta[name="robots"]').length > 0) {
              $('meta[name="robots"]').remove();
          }
              // console.log("Meta tag removed.");
      }
      counter++;
      if (counter >= 10) {
          clearInterval(checkInterval);
              // console.log("Meta function closed.");
      }
  }, 5000);
  // $(window).on('load', '.main_popup_wrapper', function(){
  //     $('.main_popup_wrapper').fadeIn();
  // });
  const isNewsletterAccepted = localStorage.getItem('Newsletter');
    if (!isNewsletterAccepted) {
        $(".main_popup_wrapper").delay(1).fadeIn();
    } 
  else{
     $(".main_popup_wrapper").fadeOut();
  }
  // $(document).mouseup(function(e){
  //   var container = $(".main_popup_wrapper .cdk_popup");
  //   if(!container.is(e.target) && container.has(e.target).length === 0){
  //     localStorage.setItem('Newsletter', 'accepted');
  //       $('.main_popup_wrapper').fadeOut();
  //   }
  // });
    $(document).on('click', '.close_icon,.popup_close span', function() {
        localStorage.setItem('Newsletter', 'accepted');
        $('.main_popup_wrapper').fadeOut();
    });
  
  if (window.location.href.indexOf("challenge") > -1) {
        $("body").addClass("challenge-page");
        $('html, body').scrollTop(0);
    }
});
